import Vue from "vue";
import { validationMixin } from "vuelidate";
import required from "vuelidate/lib/validators/required";
import helper from "../dashRequestHelper.js";


(function (window) {
    var vm = new Vue({
        el: "#forgotPasswordApp",
        data: {
            username: "",
            errors: [],
            resetExecuted: false
        },
        methods: {
            resetPassword: resetPassword
        },
        mixins: [validationMixin],
        validations: {
            username: {
                required
            }
        },
        mounted: function () {
            this.$nextTick(() => {
                this.$refs.username.focus();
            });
        }
    });

    function resetPassword() {
        vm.errors = [];
        if (vm.$v.$invalid) {
            vm.$v.username.$touch();
            return;
        }

        helper.get(window.appUrls.forgotPasswordApiResetPassword + "?username=" + vm.username).then((response) => {
            if (response.data.Success) {
                vm.resetExecuted = true;
            } else {
                vm.errors.push(response.data.Message);
            }
        });

    }

})(window);